import React from "react";

export const AiEditorIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M5.01343 8.56433L4.53906 10.2246L4.0647 8.56433C3.81554 7.69229 3.13388 7.01063 2.26184 6.76147L0.601562 6.28711L2.26184 5.81274C3.13389 5.56359 3.81554 4.88193 4.0647 4.00989L4.53906 2.34961L5.01343 4.00989C5.26258 4.88193 5.94424 5.56359 6.81629 5.81274L8.47656 6.28711L6.81628 6.76147C5.94424 7.01063 5.26258 7.69229 5.01343 8.56433Z"
      stroke="#1E1E1E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.94007 4.37059L9.78906 4.97461L9.63806 4.37059C9.46171 3.66522 8.91096 3.11446 8.20558 2.93811L7.60156 2.78711L8.20558 2.6361C8.91096 2.45976 9.46171 1.909 9.63806 1.20363L9.78906 0.599609L9.94007 1.20363C10.1164 1.909 10.6672 2.45976 11.3725 2.6361L11.9766 2.78711L11.3725 2.93811C10.6672 3.11446 10.1164 3.66522 9.94007 4.37059Z"
      stroke="#1E1E1E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.14404 11.2847L8.91406 11.9746L8.68409 11.2847C8.55345 10.8928 8.24591 10.5852 7.85399 10.4546L7.16406 10.2246L7.85399 9.99463C8.24591 9.86399 8.55345 9.55645 8.68409 9.16454L8.91406 8.47461L9.14404 9.16454C9.27468 9.55645 9.58222 9.86399 9.97414 9.99463L10.6641 10.2246L9.97414 10.4546C9.58222 10.5852 9.27468 10.8928 9.14404 11.2847Z"
      stroke="#1E1E1E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileExplorerIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M0.601562 5.84961V5.41211C0.601562 4.68724 1.18919 4.09961 1.91406 4.09961H10.6641C11.3889 4.09961 11.9766 4.68724 11.9766 5.41211V5.84961M6.90778 2.09333L5.67034 0.855891C5.50625 0.691797 5.28369 0.599609 5.05163 0.599609H1.91406C1.18919 0.599609 0.601562 1.18724 0.601562 1.91211V8.91211C0.601562 9.63698 1.18919 10.2246 1.91406 10.2246H10.6641C11.3889 10.2246 11.9766 9.63698 11.9766 8.91211V3.66211C11.9766 2.93724 11.3889 2.34961 10.6641 2.34961H7.5265C7.29444 2.34961 7.07188 2.25742 6.90778 2.09333Z"
      stroke="black"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CodeEditorIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M9.78906 2.35059L12.8516 5.41309L9.78906 8.47559M3.66406 8.47559L0.601562 5.41309L3.66406 2.35059M8.03906 0.600586L5.41406 10.2256"
      stroke="#1E1E1E"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PickIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1E1E1E"
    strokeWidth="2"
  >
    <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" />
    <path d="M13 13l6 6" />
  </svg>
);

export const ClearChatIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1E1E1E"
    strokeWidth="2"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

export const HidePanelIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1.75 12.25L1.75 1.75M7 9.62502L4.375 7.00002M4.375 7.00002L7 4.37502M4.375 7.00002L12.25 7.00002"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const getPanelHeaderConfig = ({
  panelMode,
  sidePanelView,
  showCodeEditor,
}) => {
  if ((panelMode || sidePanelView) === "ai") {
    return { label: "AI Editor", icon: <AiEditorIcon /> };
  }

  if (panelMode === "files") {
    return { label: "File Explorer", icon: <FileExplorerIcon /> };
  }

  if (showCodeEditor) {
    return { label: "Code Editor", icon: <CodeEditorIcon /> };
  }

  return { label: "Code Editor", icon: <CodeEditorIcon /> };
};
